"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleSessionBuilder = void 0;
const ArticleLanguageTagMapper_1 = require("./ArticleLanguageTagMapper");
const CadLanguageTagMapper_1 = require("./CadLanguageTagMapper");
const LocaleUtil_1 = require("./LocaleUtil");
/**
 * The `LocaleSessionBuilder` creates `LocaleSession`.
 */
class LocaleSessionBuilder {
    static build(params) {
        const articleLanguageTagMapper = new ArticleLanguageTagMapper_1.ArticleLanguageTagMapper(params.localeConfig.availableArticleLanguageTags, params.localeConfig.defaultArticleLanguageTags);
        const cadLanguageTagMapper = new CadLanguageTagMapper_1.CadLanguageTagMapper(params.localeConfig.defaultCadClickLanguageTag);
        // We need to have the priceCountry from the `ShopSession` until we have a defined value here.
        const shopCurrency = params.shopPriceCountry
            ? LocaleUtil_1.LocaleUtil.getCurrencyByPriceCountry(params.shopPriceCountry).code
            : undefined;
        return {
            userLanguageTag: params.userLanguageTag,
            userArticleLanguageTag: articleLanguageTagMapper.mapLanguageTag(params.userLanguageTag),
            userCadClickLanguageTag: cadLanguageTagMapper.mapLanguageTag(params.userLanguageTag),
            userCountry: params.userCountry,
            shopLanguageSubtag: params.shopLanguageSubtag,
            shopCountry: params.shopCountry,
            shopLanguageTag: `${params.shopLanguageSubtag}-${params.shopCountry}`,
            shopPriceCountry: params.shopPriceCountry,
            shopCurrency,
            iSalesLanguageTag: params.iSalesLanguageTag,
            iSalesArticleLanguageTag: params.iSalesLanguageTag
                ? articleLanguageTagMapper.mapLanguageTag(params.iSalesLanguageTag)
                : undefined,
            iSalesCountry: params.iSalesCountry,
            iSalesCurrency: params.iSalesCurrency,
            artNrCountry: LocaleUtil_1.LocaleUtil.findArtNrCountry(params.userCountry, params.iSalesCountry),
            iaMontageCountry: 'DE',
            unitSystem: LocaleUtil_1.LocaleUtil.findUnitSystem(params.userCountry, params.iSalesCountry),
            igusDomain: params.igusDomain,
        };
    }
}
exports.LocaleSessionBuilder = LocaleSessionBuilder;
//# sourceMappingURL=LocaleSessionBuilder.js.map